export enum DocumentStatus {
    PENDING = 'PENDING',
    VALIDATE = 'VALIDATE',
    RECTIFY = 'RECTIFY',
}
